import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledUserStatus = styled.div`
  ${fontQuicksand()};
  display: flex;
  justify-content: center;
  padding: 6rem 0 0 0;
  border-radius: 5rem;
  color: ${Colors.BLUE};
`;

export const StyledLabel = styled.span``;
